import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/firebase-auth'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyCC1uqirWo1UNuRCktCdgnENaLjIWhSnHM",
  authDomain: "crcbmgt.firebaseapp.com",
  projectId: "crcbmgt",
  storageBucket: "crcbmgt.appspot.com",
  messagingSenderId: "955110403562",
  appId: "1:955110403562:web:ef71cc01422aa1591fd693",
  measurementId: "G-Z375XEJ0FC"
};
// Initialize Firebase
const fb = firebase.initializeApp(firebaseConfig)
const db = firebase.firestore()

export {fb,db}


// WEBPACK FOOTER //
// ./src/firebase.js